import { Storage } from "aws-amplify";

export const subirArchivo = async (file, ruta, nombre) =>
  await Storage.put(`${ruta}${nombre}`, file)
    .then((res) => ({
      url: process.env.REACT_APP_URL_BUCKET,
      key: `public/${res.key}`,
      urlComplete: `${process.env.REACT_APP_URL_BUCKET}public/${res.key}`,
    }))
    .catch((err) => err);

export const extenciones = {
  "image/png": ".png",
  "image/jpeg": ".jpeg",
  "image/jpg": ".jpg",
};
